// hooks/useYearSelection.js
import { useState } from 'react';

export const useYearSelection = (initialYear = new Date().getFullYear()) => {
  const [selectedYear, setSelectedYear] = useState(initialYear);

  const handleYearChange = (value) => {
    setSelectedYear(parseInt(value));
  };

  return { selectedYear, handleYearChange };
};